import {useState, useEffect} from 'react';
import Player from '@vimeo/player';

const cachedDurations = {};

const getVimeoDuration = async vimeoId => {
  const div = document.createElement('div');
  div.setAttribute('style', 'display: none;');
  document.body.appendChild(div);
  // div.setAttribute('id', id);
  const player = new Player(div, {id: vimeoId, width: 1});
  const duration = await player.getDuration();
  return duration;
};

const useVimeoDuration = vimeoId => {
  const [videoDuration, setVideoDuration] = useState(null);
  useEffect(() => {
    if (!vimeoId) return;

    if (cachedDurations[vimeoId]) {
      setVideoDuration(cachedDurations[vimeoId]);
      return;
    }

    getVimeoDuration(vimeoId)
      .then(duration => {
        cachedDurations[vimeoId] = duration;
        setVideoDuration(duration);
      })
      .catch();
  }, [vimeoId]);

  if (!vimeoId) return [true, 0];

  return [!!videoDuration, videoDuration || 0];
};

export default useVimeoDuration;
